import PlaidModal from "./PlaidModal"

export default PlaidModal
